import {
    PETS_ERROR,
    PETS_RESET,
    PETS_SAVE_START,
    PETS_SAVE_SUCCESS,
    PetsAction
} from 'actions/pets/PetsActionsTypes';
import { PetsState, PetsStatus } from 'reducers/pets/PetsState';
import { Reducer } from 'redux';

const initialState: PetsState = {
    loading: false,
    status: PetsStatus.Initial
};

export const petsReducer: Reducer<PetsState, PetsAction> = (state = initialState, action) => {
    switch (action.type) {
        case PETS_RESET:
            return initialState;
        case PETS_ERROR:
            return {
                ...state,
                loading: false,
                status: PetsStatus.Error
            };
        case PETS_SAVE_START:
            return {
                ...state,
                loading: true,
                status: PetsStatus.SaveStart
            };
        case PETS_SAVE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: PetsStatus.SaveSuccess,
                pet: action.payload.pet
            };
        default:
            return state;
    }
};
